import React from 'react';


const SalesByItemStatusCard = ({statusTitle, serviceType, noOfOrders, noOfOrdersClassName, revenue, dropDown}) => {



    return (
        <section>
            <div className='order-status-card-container sales-by-item-status-card manager-customer-status-card'>
                <div className='flex gap-4'>
                    {/* <div>{icon}</div> */}
                    <p className='due-text'>{statusTitle}</p>
                    <section>
                        {dropDown}
                    </section>
                </div>
                <div className='flex flex-col gap-20 mt-7'>
                    <div>
                        <p className={`service-type ${noOfOrdersClassName}`}>{serviceType}</p>
                    </div>
                    
                </div>
                <div className='customer-active-section'>
                    {revenue ? (<p className='size mt-2'>{revenue} <span className='customer-active-text'>revenue </span> </p>) : (<p className='size mt-2'>{noOfOrders} <span className='customer-active-text'>{noOfOrders === 1 ? 'order' : 'orders' }</span> </p>)}
                    
                </div>
            </div>
        </section>
    );
}

export default SalesByItemStatusCard;
